import { render } from "./MenuItemList.vue?vue&type=template&id=1f5c3a5d"
import script from "./MenuItemList.vue?vue&type=script&lang=js"
export * from "./MenuItemList.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__